// axios
import axios from 'axios'

export default axios.create({
  //baseURL: 'http://10.0.1.34:8080/GPSAdministracao',
  //baseURL: 'http://10.10.1.123:8080/GPSAdministracao',  
  //baseURL: 'http://23.23.175.15:8080/GPSAdministracao'
  baseURL: process.env.VUE_APP_URL_SERVIDOR + '/GPSAdministracao'
})
